import SignOutPageView from "./SignOutPageView";

function SignOutPage() {
  return <SignOutPageView />;
}

export default SignOutPage;
